import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CompletedComponent } from './questionnaire/completed/completed.component';
import { WelcomeComponent } from './questionnaire/welcome/welcome.component';
import { DetailsComponent } from './questionnaire/details/details.component';
import { QuestionsComponent } from './questionnaire/questions/questions.component';
import { RouterLink, RouterOutlet } from '@angular/router';
import { ComponentsModule } from '../components/components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InviteLinkLoadingComponent } from './questionnaire/invite-link-loading/invite-link-loading.component';
import { NotFoundComponent } from './error/not-found/not-found.component';
import { MatRippleModule } from '@angular/material/core';
import { LoginComponent } from './login/login.component';
import { QuestionnaireUnavailableComponent } from './questionnaire/questionnaire-unavailable/questionnaire-unavailable.component';
import { TwoFactorComponent } from './two-factor/two-factor.component';
import { RegisterComponent } from './register/register.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { ConfirmSetupTwoFactorDialogComponent } from './login/confirm-setup-two-factor-dialog/confirm-setup-two-factor-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { OauthLoginComponent } from './oauth/oauth-login/oauth-login.component';
import { PipesModule } from '../pipes/pipes.module';
import { MatSelectModule } from '@angular/material/select';
import { EmailVerificationSetupComponent } from './email-verification-setup/email-verification-setup.component';
import { LanguageDropdownComponent } from '../components/navbar/translation/language-dropdown.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { QuestionnaireAnalyticsComponent } from './admin/questionnaire/analytics/questionnaire-analytics.component';

@NgModule({
  declarations: [
    CompletedComponent,
    WelcomeComponent,
    DetailsComponent,
    QuestionsComponent,
    InviteLinkLoadingComponent,
    NotFoundComponent,
    LoginComponent,
    QuestionnaireUnavailableComponent,
    TwoFactorComponent,
    RegisterComponent,
    ResetPasswordComponent,
    EmailVerificationComponent,
    ConfirmSetupTwoFactorDialogComponent,
    ForgotPasswordComponent,
    OauthLoginComponent,
    EmailVerificationSetupComponent,
  ],
  imports: [
    CommonModule,
    RouterLink,
    ComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    MatRippleModule,
    MatDialogModule,
    PipesModule,
    MatSelectModule,
    NgOptimizedImage,
    LanguageDropdownComponent,
    MatProgressSpinner,
    QuestionnaireAnalyticsComponent,
    RouterOutlet,
  ],
  exports: [CompletedComponent],
})
export class PagesModule {}
